import {customElement, bindable} from 'aurelia-framework';

@customElement('sio-sort-indicator')
export class SortIndicator
{
    @bindable sort;
}
